<template>
  <div>
    <GmapMarker 
      v-for="(vehicle,index) in getVehicles" :key="index"
      :position="handleMarkerPosition(vehicle)"
      :clickable="true" @click="handleClickMarker(vehicle)"
      :options="markerOptions"
      :icon="lastPositionMarker"/>
    <GmapPolygon v-for="zone in getZoneGeostrings" :key="zone.id" :paths="zone.path"/>
  </div>
</template>

<script>
  import {LAST_POSITION_MARKER} from '../utils/staticsRef'
  import {mapGetters, mapActions} from 'vuex'
  import {loaded} from 'vue2-google-maps'

  /**
   * Marcadores para el mapa de vehículos
   *
   * @author Manuel Ochoa
   */
  export default {
    name: "map-vehicle-markers",
    data() {
      return {
        /**
         * @var{Object} Opciones para la personalización del marcador
         * @see {@link https://developers.google.com/maps/documentation/javascript/reference/3.exp/marker#MarkerOptions | MarkerOptions}
         */
        markerOptions: {},
        lastPositionMarker: LAST_POSITION_MARKER

      }
    },
    computed: {
      ...mapGetters(['getVehicles', 'getSelectedVehicle']),
      ...mapGetters({ getZoneGeostrings: 'filters/getZoneGeostrings'})
    },
    methods: {
      /**
       * Devuelve la posición del vehículo en un formato que comprende el marcador de Google Maps
       * @param vehicle
       * @returns {{lat: *|number, lng: *|number}}
       */
      handleMarkerPosition(vehicle) {
        // console.log('VEHICLE', vehicle)
        let {lastPosition} = vehicle
        return {
          lat: vehicle.lastPosition.lat,
          lng: vehicle.lastPosition.lng
        }
      },
      /**
       * Selecciona el vehículo en Vuex y luego emite un evento con la posición del marcador
       *
       * @param vehicle
       */
      handleClickMarker(vehicle) {
        this.selectVehicle(vehicle)
        let {lastPosition} = vehicle
        this.$emit('centerMarker', {
          lat: vehicle.lastPosition.lat,
          lng: vehicle.lastPosition.lng
        })
      },
      ...mapActions(['selectVehicle'])
    },
    /**
     * Usa la promesa `loaded`, la cual espera que google maps este disponible y luego define la animación para los marcadores
     */
    mounted() {
      loaded.then(() => {
        this.markerOptions = {
          animation: window.google.maps.Animation.DROP
        }
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MapVehicleMarkers.vue